import { useState } from 'react'
import { HStack, Input, Text, IconButton, Field } from '@chakra-ui/react';
import { FiEdit2, FiCheck, FiX } from 'react-icons/fi'

interface InlineEditFieldProps {
  label: string
  value: string | undefined
  fieldName: string
  canEdit: boolean
  onSave: (fieldName: string, value: string) => void
  type?: 'text' | 'email' | 'tel' | 'date'
  isSaving?: boolean
}

export function InlineEditField({
  label,
  value,
  fieldName,
  canEdit,
  onSave,
  type = 'text',
  isSaving,
}: InlineEditFieldProps) {
  const [isEditing, setIsEditing] = useState(false)
  const [editValue, setEditValue] = useState(value ?? '')

  const handleEdit = () => {
    setEditValue(value ?? '')
    setIsEditing(true)
  }

  const handleSave = () => {
    onSave(fieldName, editValue)
    setIsEditing(false)
  }

  const handleCancel = () => {
    setEditValue(value ?? '')
    setIsEditing(false)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleSave()
    if (e.key === 'Escape') handleCancel()
  }

  if (isEditing) {
    return (
      <Field.Root>
        <Field.Label fontSize="xs" color="gray.500" mb={1}>{label}</Field.Label>
        <HStack>
          <Input
            size="sm"
            type={type}
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            onKeyDown={handleKeyDown}
            autoFocus
          />
          <IconButton
            aria-label="Save"
            size="sm"
            colorPalette="green"
            variant="ghost"
            onClick={handleSave}
            loading={isSaving}><FiCheck /></IconButton>
          <IconButton aria-label="Cancel" size="sm" variant="ghost" onClick={handleCancel}><FiX /></IconButton>
        </HStack>
      </Field.Root>
    );
  }

  return (
    <Field.Root>
      <Field.Label fontSize="xs" color="gray.500" mb={1}>{label}</Field.Label>
      <HStack gap={1}>
        <Text fontSize="sm">{value || '-'}</Text>
        {canEdit && (
          <IconButton
            aria-label={`Edit ${label}`}
            size="xs"
            variant="ghost"
            color="gray.400"
            onClick={handleEdit}><FiEdit2 /></IconButton>
        )}
      </HStack>
    </Field.Root>
  );
}
